import { render, staticRenderFns } from "./StickerEditor.vue?vue&type=template&id=033cdd79&scoped=true&"
import script from "./StickerEditor.vue?vue&type=script&lang=js&"
export * from "./StickerEditor.vue?vue&type=script&lang=js&"
import style0 from "./StickerEditor.vue?vue&type=style&index=0&id=033cdd79&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033cdd79",
  null
  
)

export default component.exports